import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import style from "../css/oddsCard.css";
import { getText } from "../../../../../helpers/localization";
import OddsButton from "./oddsButton";

const mapStateToProps = (state, ownProps) => {
  return {
    openBetsSimpleList: state.vpp.openBetsSimpleList,
    selectedOddsType: state.vpp.selectedOddsType,
    systemLanguage: state.vpp.systemLanguage,
  };
};

class OddsCard extends Component {
  constructor(props) {
    super(props);

    let store = this.props.store;
    let storeData = store.getState();

    this.state = {
      openBetsSimpleList: storeData.vpp.openBetsSimpleList,
      selectedOddsType: storeData.vpp.selectedOddsType,
      systemLanguage: storeData.vpp.systemLanguage,
    };
  }

  componentWillReceiveProps(nextProps) {
    let store = nextProps.store;
    let storeData = store.getState();

    if (nextProps && storeData) {
      this.setState({
        openBetsSimpleList: storeData.vpp.openBetsSimpleList,
        selectedOddsType: storeData.vpp.selectedOddsType,
        systemLanguage: storeData.vpp.systemLanguage,
      });
    }
  }

  render() {
    let includeMarketLabel =
      this.props.includeMarketLabel === undefined
        ? true
        : this.props.includeMarketLabel;
    let text;
    let textBottom;
    if (includeMarketLabel) {
      if (isNaN(this.props.market.selection)) {
        // the following switch case helps in modifying text based on market code.
        // under over 220
        // correct score 221
        // winning margin 222
        // handicap 219
        switch (this.props.market.code) {
          case 219:
            text = this.props.market.selection
            .replace("Player 1", this.props.homeTeam.split(" ")[1])
            .replace("To Win", "")
            .replace("Player 2", this.props.awayTeam.split(" ")[1])
            .replace("To Win", "")
            .trim();
            break;
          case 220:
            text = getText(
              this.props.market.selection.split(" ")[0],
              this.props.store,
              [this.props.market.selection.split(" ")[1]]
            );
            break;
          case 221:
            text = text = this.props.market.selection;
            break;
          case 222:
            text = getText(this.props.market.selection.replace("Player 1", "").replace("Player 2", "").trim(), this.props.store);
            break;
          default:
            text = getText(this.props.market.selection, this.props.store);
            break;
        }
      } else {
        text = this.props.market.selection;
      }
      if (this.props.multiDisplay) {
        let textSplit = text.split("/");
        text = textSplit[0];
        textBottom = getText("slash", this.props.store) + textSplit[1];
      }
    }
    let emptyRow = this.props.market === "empty";
    let multiLineDisplay = (
      <Fragment>
        <div id={"line1"} className={style.innerText}>
          {text}
        </div>
        <div id={"line2"}>{textBottom}</div>
      </Fragment>
    );
    return (
      <div className={` ${style.marketType} `}>
        <div className={` ${style.marketText}`}>
          {emptyRow ? "" : this.props.multiDisplay ? multiLineDisplay : text}
        </div>
        <OddsButton
          active={true}
          buttonStyle={style.buttonCustomStyle}
          market={this.props.market}
          store={this.props.store}
          circleSize={"large"}
          customStyle={style.customButtonContainer}
        ></OddsButton>
      </div>
    );
  }
}

export default connect(mapStateToProps)(OddsCard);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/tennis/components/oddsCard.js